﻿import { CookieStorage } from './cookie-storage';

export function getStorage(storageType) {
    switch (storageType) {
        case 'cookieStorage':
            return new CookieStorage({
                domain: window.location.hostname,
                expires: null,
                path: '/',
                secure: false
            });

        case 'sessionStorage':
            return sessionStorage;

        default:
            return localStorage;
    }
}